import { render, staticRenderFns } from "./SketchForExportOld.vue?vue&type=template&id=b1d41620&scoped=true"
import script from "./SketchForExportOld.vue?vue&type=script&lang=js"
export * from "./SketchForExportOld.vue?vue&type=script&lang=js"
import style0 from "./SketchForExportOld.vue?vue&type=style&index=0&id=b1d41620&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d41620",
  null
  
)

export default component.exports